import DapDSInputGroup from './input-group.component'

export * from './input-group.component'
export default DapDSInputGroup

DapDSInputGroup.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-input-group': DapDSInputGroup
  }
}
